import { Avatar, Box, ButtonBase, Stack, styled, Typography, useTheme } from '@mui/material'
import { orange } from '@mui/material/colors'
import Modal from '../../../molecules/Modal'

const notifications = [
    {
        name: "User Log",
        content: "Samuel changed password",
        code: "UL"
    },
    {
        name: "User Log",
        content: "Samuel changed password",
        code: "UL"
    },
    {
        name: "User Log",
        content: "Samuel changed password",
        code: "UL"
    },
]

export default function NotificationsModal({visible, setVisibility}) {

    return (
        <Modal
            title="Activity Center"
            subtitle="Latest activities in your shop"
            visible={visible}
            setVisibility={setVisibility}
        >
            <Stack
                sx={{
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    flexWrap: "wrap",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: "0.3rem"
                }}
                direction = "column"
                spacing={1}
            >

                {
                    notifications.map((not, index)=>(
                        <NotificationItem key={index} name={not.name} type={not.type} code={not.code} />
                    ))
                }

            </Stack>
            
        </Modal>
    )
}

const CustomButtonBase = styled(ButtonBase)(({theme})=>({
    width: "100%",
    padding: "1rem",
    border: "0.5px solid rgba(255,255,255,0.1)",
    display: "flex",
    borderRadius: theme.shape.borderRadius,
    alignItems: "center"
}))

const NotificationItem = ({name, type, code})=>{

    const theme = useTheme()

    return(

        
        <CustomButtonBase>
    
            <Stack
                direction="row"
                spacing={1}
                
            >
                <Avatar
                    sx={{
                        bgcolor: "grey.300",
                        height: "2rem",
                        width: "2rem",
                        color: theme.palette.primary.dark,
                        border: `1px solid ${orange['700']}`,
                        alignSelf: "flex-start"
                    }}
                >
                    UL
                </Avatar>
                
                <Box>
                    <Typography lineHeight="1rem" textAlign="left" >
                        <Typography variant="subtitle1" fontSize="16px" fontWeight="700" color={orange['700']} >User Logs</Typography>
                        <Typography variant="subtitle2" fontSize="14px" fontWeight="200" color="grey.200" >Samuel Asare changed password</Typography>
                    </Typography>
                </Box>
            </Stack>
    
        </CustomButtonBase>
    
    )

}